import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import get from "lodash/get"
import { selectEvent } from "src/engine/modules/calendar"
import selectEntities from "./entities"

// TODO: needs reselect
export default function entityItem(state, model, id) {
  const { name } = normalizeModel(model)
  const entitiesState = selectEntities(state)

  let result
  const entity = get(entitiesState, `${name}.items.${id}`)
  if (entity) {
    result = entitiesState[name].items[id]
  } else if (model.name === `events`) {
    result = { data: selectEvent(state, id) || null, error: null }
  } else {
    result = null
  }
  return result
}
